import { Component, ElementRef, ViewChild } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';

@Component({
    selector: 'text-editor',
    template: `
        <app-mazars-input-text
            #input
            [(ngModel)]="value"
            [padding]="'10px 15px'"
            [placeholder]="placeholder"
            [tooltipText]="tooltipText"
            [uid]="'text-editor-' + placeholder"
            style="width: 100%; height: 43px;"
        ></app-mazars-input-text>
    `,
})
export class TextEditorComponent implements ICellEditorAngularComp {
    @ViewChild('input', {read: ElementRef}) input: ElementRef;
    public value!: number;
    public placeholder: string;
    public tooltipText: string;

    agInit(params: ICellEditorParams): void {
        this.value = params.value;
        this.placeholder = params.data.placeholder;
        this.tooltipText = params.data.tooltipText;
    }

    focusIn() {
        setTimeout(() => this.input.nativeElement.querySelector('input').focus());
    }

    getValue(): any {
        return this.value;
    }

    isCancelBeforeStart(): boolean {
        return false;
    }

    isCancelAfterEnd(): boolean {
        return false;
    }
}
